import { createContext } from 'react'
import { IDraftContext } from './DraftContextProviderView'

export default createContext({} as IDraftContext)
